import { render, staticRenderFns } from "./Callcenter.vue?vue&type=template&id=c5bd9f22&scoped=true"
import script from "./Callcenter.vue?vue&type=script&lang=js"
export * from "./Callcenter.vue?vue&type=script&lang=js"
import style0 from "./Callcenter.vue?vue&type=style&index=0&id=c5bd9f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bd9f22",
  null
  
)

export default component.exports